  export const privacyPolicyContent1 = [
     "This privacy policy (Policy) applies when PlatinX Exchange is acting as a data controller with respect to the personal data of our users. This Policy describes how we collect, use and share personal data of consumer users across our websites, including www.platinx.exchange, PlatinX Exchange mobile and desktop application (the App) and services offered to users (collectively with the Website and the App, the Services), and from our partners and other third parties. When using any of our Services you consent to the collection, transfer, storage, disclosure, and use of your personal data as described in this Policy. This Policy does not apply to anonymized data, as it cannot be used to identify you.",
    "Please read this Policy carefully to understand our policies and practices regarding your personal data and how we will treat it. By accessing or using the Services, you agree to this Policy. Our Services also incorporate privacy controls which affect how we will process your personal data.",
    "This Policy may change from time to time. Your continued use of the Services after we make changes is deemed to be acceptance of those changes, so please check the Policy periodically for updates."
  ];
   export const policyPoints = [
    {
      title: '1.1',
      content:
        'In this policy, we, us, our and PlatinX Exchange refer to PlatinX Exchange. For more information about us and how to contact us, visit www.platinx.exchange',
    },
    {
      title: '1.2',
      content:
        '‘Digital Assets’ refer to digital representation of value, also known as cryptocurrency, crypto assets, virtual currency, crypto token or digital commodity. This is based on cryptographic protocol and used as medium of exchange or store of value. The protocols used here could be centralized or decentralized, closed or open-source.',
    },
    {
      title: '1.3',
      content:
        '‘User’ refers to all verified customers who log on to our website and utilize the services of PlatinX Exchange.',
    },
    {
      title: '1.4',
      content:
        '‘User Account’ refers to the account, verified and accessible via the company’s services including services of the digital wallet to store your digital assets.',
    },
    {
      title: '1.5',
      content:
        '‘Personal Information’ refers to user’s personal data including but not limited to name, identification number, security number, nationality, gender, signature, utility bills, photographs, contact details, home address, location data and such.',
    },
  ];
  
  export const personalInfoList = [
    'Full legal name',
    'Home address, including country of residence',
    'Email address',
    'Mobile phone number',
    'Date of birth',
    'Proof of identity (e.g., driver’s license, passport, or government-issued identity card)',
    'Social Security Number or any comparable identification number issued by a government',
    'Other Personal Information that is deemed helpful in verifying whether you are eligible to register on PlatinX Exchange website',
    'Other Personal Information that is deemed helpful in ensuring our compliance with legal obligations under applicable anti-money laundering (AML) obligations, Know Your Customer (KYC) compliance and ensuring data management and communication channels to communicate with user to ensure best services',
    'Other Personal Information that is required by any court order, any applicable law, administrative regulation or any order of any other competent government agency',
  ];

  export const dataDisclosurePoints = [
    {
      title: '4.1',
      content:
        'We may disclose your personal data to any member of our group of companies (this means our subsidiaries, our ultimate holding company and all its subsidiaries) insofar as reasonably necessary for the purposes, and on the legal bases, set out in this policy.',
    },
    {
      title: '4.2',
      content:
        'We may disclose Service Data to a variety of third-party service providers insofar as reasonably necessary to improve the functionalities of the Services. For example, we may disclose Service Data to obtain useful analytics, provide in-app support to mobile app users, determine location data and provide search engine functionality to our users.',
    },
    {
      title: '4.3',
      content:
        'We may share aggregated data (information about our users that we combine together so that it no longer identifies or references an individual user) and other anonymized information for regulatory compliance, industry and market analysis, demographic profiling, marketing and advertising, and other business purposes.',
    },
    {
      title: '4.4',
      content:
        'In the event of a dispute in P2P transaction, we may disclose some of your Personal Data with the counterparty to such transaction to the extent we deem required, in our discretion, to resolve the dispute.',
    },
    {
      title: '4.5',
      content:
        'In addition to the specific disclosures of personal data set out in this Section 3, we may disclose your personal data if we believe that it is reasonably necessary to comply with a law, regulation, legal process, or governmental request; or in order to protect your vital interests or the vital interests of another natural person; to protect the safety or integrity of the Services, or to explain why we have removed content or accounts from the Services; or to address fraud, security, or technical issues; or to protect our rights or property or the rights or property of those who use the Services.',
    },
    {
      title: '4.6',
      content:
        'We offer individuals the opportunity to choose (opt out) whether their personal information is (i) to be disclosed to a third party or (ii) to be used for a purpose that is materially different from the purpose(s) for which it was originally collected or subsequently authorized by the individuals. In order to opt out from disclosure of your personal information, please write to us at www.platinx.exchange',
    },
    {
      title: '4.7',
      content:
        'PlatinX Exchange does not sell, trade, transfer Personal Information to external parties, or allow external parties to do so on our website. However, to the extent necessary for 1) proper functioning of PlatinX Exchange website and improvement of our services 2) compliance with any of the applicable laws, regulations, rules or any order of courts or other competent authorities or 3) due protection of the rights, property, or safety of us or other persons, the following parties shall be excluded from such promise: our affiliates and trusted third party vendors we engage to help us operating our website, managing our business, or providing services directly and indirectly to the Users, provided that such parties understand and agree to keep such Personal Information confidential. Nevertheless, your Personal Information will not be provided to external parties for marketing, advertising or other purposes, unless an authorization is directly obtained from you.',
    },
  ];

  export const userRightsPoints = [
    {
      title: '5',
      content:
        'In this Section 5, we have summarized the rights that you have under data protection law based on whether you are an EEA resident (an EEA Resident) or you are not a resident of the EEA (a Non-EEA Resident). Some of the rights are complex, and not all of the details have been included in our summaries. Accordingly, you should read the relevant laws and guidance from the regulatory authorities for a full explanation of these rights.',
    },
    {
      title: '5.1',
      content:
        'Non-EEA Residents may access and verify their Personal Information held by PlatinX Exchange by submitting a written request to us at support@platinx.exchange',
    },
    {
      title: '5.2',
      content:
        'EEA Residents. If you are an EEA Resident, your principal rights under data protection law are listed below:',
    },
  ];
  
  export const eeaRights = [
    'the right to access;',
    'the right to rectification;',
    'the right to erasure;',
    'the right to restrict processing;',
    'the right to object to processing;',
    'the right to data portability;',
    'the right to complain to a supervisory authority;',
    'the right to withdraw consent.',
  ];  
  
  export const securityMeasures = [
    {
      title: '6.1',
      content:
        'PlatinX Exchange is committed to appropriate physical, electronic and technical measures to protect and safeguard your personal information. We take security measures in this regard that are not limited to –',
      points: [
        'Physical measures: Records of your Personal Information will be stored in a properly locked place against loss, theft, unauthorized use, disclosure, or modification.',
        'Electronic measures: Electronic data that contain your Personal Information will be stored in properly encrypted computer systems and storage media that are subject to strict login/access restrictions.',
        'Technical measures: Proper encryption techniques, including but not limited to Secure Socket Layer Encryption technology, may be used to protect your Personal Information.',
        'Managerial measures: Only staff members duly authorized by us can access your Personal Information, and these staff members are duly trained and monitored to comply with our internal code of ethics concerning personal data protection.',
        'Other measures that we deem necessary in ensuring the safety of your Personal Information.',
      ],
    },
    {
      title: '6.2',
      content:
        'To help protect your information and account from misuse, you should never disclose your login credentials and password of your PlatinX Exchange user account. We shall not be held liable for damage or loss of any kind caused directly or indirectly by your failure to maintain the secrecy of your login information.',
      points: [],
    },
  ];
  